import React from 'react';
import { useGallery } from '../context/GalleryContext';
import { motion } from 'framer-motion';
import './Artists.css';

const Artists = () => {
  const { artists, artistsLoading, artistsError } = useGallery();

  if (artistsLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Discovering artists...</p>
      </div>
    );
  }

  if (artistsError) {
    return (
      <div className="error-container">
        <h2>Something went wrong</h2>
        <p>{artistsError}</p>
        <button onClick={() => window.location.reload()} className="retry-btn">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="artists-page">
      <div className="artists-header">
        <h1>Featured Artists</h1>
        <p>Explore the creative minds behind the masterpieces.</p>
      </div>

      <div className="artists-grid">
        {artists.map((artist, index) => (
          <motion.div
            key={artist.id}
            className="artist-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="artist-card-header">
              <div className="artist-bg"></div>
              <div className="artist-avatar">
                <img src={artist.profile_image.large} alt={artist.name} />
              </div>
            </div>

            <div className="artist-content">
              <h3>{artist.name}</h3>
              <span className="artist-username">@{artist.username}</span>

              <div className="artist-stats">
                <div className="stat">
                  <span className="stat-value">{artist.total_photos}</span>
                  <span className="stat-label">Photos</span>
                </div>
                <div className="stat">
                  <span className="stat-value">{artist.followers_count}</span>
                  <span className="stat-label">Followers</span>
                </div>
              </div>

              <a
                href={artist.portfolio_url || `https://unsplash.com/@${artist.username}`}
                target="_blank"
                rel="noopener noreferrer"
                className="artist-btn"
              >
                View Profile
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Artists;
